import React, { useContext, useEffect, useState } from "react";
import { Text, View, StyleSheet, TouchableOpacity, Platform } from "react-native";
import { AppContext } from "../../AppContext";
import { Colors, Fonts } from "../styles/styles.js";
import * as SecureStore from "expo-secure-store";
import { useNavigation } from "@react-navigation/native";
import * as Haptic from 'expo-haptics'; // Importar Haptic

const translations = {
  ESP: {
    usersTextPrefix: "¡Ya somos",
    usersTextSuffix: "usuarios!",
    registerButtonText: "¡Regístrate!🚀",
  },
  CAT: {
    usersTextPrefix: "Ja som",
    usersTextSuffix: "usuaris!",
    registerButtonText: "Registra't!🚀",
  },
  ENG: {
    usersTextPrefix: "We are already",
    usersTextSuffix: "users!",
    registerButtonText: "Register!🚀",
  },
};

const RegisterButton = ({ onClose }) => {
  const { language, serverAddress, setToken, eraseUserData } = useContext(AppContext);
  const t = translations[language];
  const [numUsuarios, setNumUsuarios] = useState(null);
  const navigation = useNavigation();

  useEffect(() => {
    const fetchNumUsuarios = async () => {
      try {
        const response = await fetch(`${serverAddress}/api/v1/auxiliars/numUsuaris`);
        const data = await response.json();
        if (data.status === "OK" && data.data && data.data[0]) {
          setNumUsuarios(data.data[0].numUsuaris);
        }
      } catch (error) {
        console.error("Error fetching number of users:", error);
      }
    };

    fetchNumUsuarios();
  }, [serverAddress]);

  const handleRegister = async () => {
    // Ejecuta la respuesta háptica solo si no es la plataforma web
    if (Platform.OS !== "web") {
      await Haptic.impactAsync(Haptic.ImpactFeedbackStyle.Heavy);
    }

    // Limpia el contexto y el almacenamiento seguro
    setToken(null);
    eraseUserData();
    if (Platform.OS === "web") {
      localStorage.removeItem("userToken");
    } else {
      await SecureStore.deleteItemAsync("userToken");
    }
    // Cierra el modal antes de navegar
    if (onClose) onClose();
    // Navega a la pantalla de registro
    navigation.navigate("Register");
  };

  return (
    <TouchableOpacity style={styles.registerButtonContainer} onPress={handleRegister}>
      {numUsuarios !== null && (
        <Text style={styles.registerUsersText}>
          {t.usersTextPrefix} <Text style={styles.boldText}>{numUsuarios}</Text> {t.usersTextSuffix}
        </Text>
      )}
      <Text style={styles.registerButtonText}>{t.registerButtonText}</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  registerButtonContainer: {
    backgroundColor: Colors.white,
    borderColor: "green",
    borderWidth: 2,
    borderRadius: 10,
    paddingVertical: 2,
    paddingHorizontal: 8,
    alignItems: "center",
  },
  registerUsersText: {
    color: Colors.black,
    fontSize: 10,
    marginBottom: 2,
  },
  registerButtonText: {
    color: "green",
    fontSize: 12,
    fontWeight: "bold",
  },
  boldText: {
    fontWeight: "bold",
  },
});

export default RegisterButton;
